import { Pedido } from './Pedido';

export function ListaPedido({ data }) {
  if (!data) return null;
  return data?.map((item, index) => <Pedido key={item.id} item={item} isOdd={index % 2 === 0} />);
}
